import { render, staticRenderFns } from "./Applications.vue?vue&type=template&id=444a6521&scoped=true"
import script from "./Applications.vue?vue&type=script&lang=ts"
export * from "./Applications.vue?vue&type=script&lang=ts"
import style0 from "./Applications.vue?vue&type=style&index=0&id=444a6521&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444a6521",
  null
  
)

export default component.exports